// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  region: 'eu-west-1',

  identityPoolId: 'eu-west-1:dad71f75-f92e-46c7-9b25-69fff6ba6e4f',
  userPoolId: 'eu-west-1_YhxrHfEnR',
  clientId: '7m0qpqthg3karop4kl0o96p33b',
  accountId: '191356093824',
  rekognitionBucket: 'isojoenmetsastysseura',
  publicBucket: 'julkiset',
  albumName: "",
  bucketRegion: 'eu-west-1',

  ddbTableName: 'LoginTrail',

  cognito_idp_endpoint: '',
  cognito_identity_endpoint: '',
  sts_endpoint: '',
  dynamodb_endpoint: '',
  s3_endpoint: ''



};
// {"keys":[{"alg":"RS256","e":"AQAB","kid":"ig8zmqoPiJKI8LmqQBT5kmaRpzC9qpEHyDXJ9kYzbPk=","kty":"RSA","n":"pHzFhIAtZ3jJ5UxoM7O_IahpAAbkOAACfNmXg3QYdt3Guobv5WExA7hdazFtwLtxvITuYB7jCZqCRc5sm9fE6Jr_ixOQ_Y0w6T2K_wsIJ5P6kJDLaTtsgfIA-mnN4r0EF9cRhFqL9j9zBJeYOQl9aeGX6Gwc09l6_tuRONZ8o2dV5dJc3XiBZJXlxvMZ60Cr9Zkic5geWVyLYkRhHqjPu-Gx-06tiSXKaX3lVbbe61HXTEhyAVwp3EdKnpk26BR43pLGhLYKjnISAg6oYtADNukpUMBwjdxotjxyqBT22ZAdTgtX3BvL1-I6b6Pu9fOv7YdR4wa9BPO9vPou5j5Z2w","use":"sig"},{"alg":"RS256","e":"AQAB","kid":"fEyOTyd8c2g0lTjxhTGFoy3XYtymwzfva2R0KiubB/g=","kty":"RSA","n":"gFsOhi85dMy1lwyJZ-KHEeToL-kO1hHoXVf655LyIK6hGVLFd_pRpBrfU_TJ9sanlwmBNSnV7Ar62iWS6eHcuwK6WsmDM5j6lK50dHrj9TAioKd9iXaWxBvN5oZMZzcIK4KswE0wsMjLn6HXsvRbRnSxVI7hda2Il7Yimcg39An87RohQaaD_jakpGD28GCXEXOag2wJA_wHTRXT0ZcM7QJfKnNACtiaDEeVlVWxVQdYSI9KpDemC8wN1JN21PSeAwbSBFlgCHv6S5hdYZ3tP5x8KpdpjXamJzHwodSr3jkNyeWwpshMez5BgdBOUBH0KPkGjstDVgw9M8EAAGLttw","use":"sig"}]}


// WEBPACK FOOTER //
// ./src/environments/environment.ts